module.exports = __webpack_public_path__ + "img/word.0256ee04.svg";